import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import PageTitle from "../../layout/PageTitle";
import {
  SPECIALITIES_CONSTANT,
  SPECIALITY_DATA,
} from "../../constants/SpecialityConstant";
import { getSpecialities } from "../../layout/Navbar";
import Accordion from "../../common/Accordion";

function Speciality({ setTab }) {
  const { specialityId } = useParams();
  const speciality = SPECIALITIES_CONSTANT[specialityId];
  const currentSpeciality =
    SPECIALITY_DATA.filter((item) => item.id === specialityId)?.[0] || {};
  const [active, setActive] = useState(1);
  const onFAQClick = (currentActive) => {
    setActive(currentActive);
  };
  useEffect(() => {
    setTab("speciality");
  }, [active, setTab]);
  return (
    <>
      <PageTitle page={speciality} setTab={setTab} />
      <div className="site-main">
        <div className="ttm-row sidebar ttm-sidebar-left ttm-bgcolor-white clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 widget-area sidebar-left">
                <aside className="widget widget-nav-menu with-title">
                  <h3 className="widget-title">Services</h3>
                  <ul>{getSpecialities(specialityId, () => {}, setTab)}</ul>
                </aside>
                <aside
                  className="widget widget-text ttm-bgcolor-darkgrey"
                  style={{ padding: "25px" }}
                >
                  <div className="contact_class">
                    <h4>Our Location</h4>
                    <p>Thana Chowk, Ramgarh - 829122, Jharkhand, India</p>
                    <br />
                    <h4>Quick Contact</h4>
                    <p>Email: prasadeyehospital021@gmail.com</p>
                    <p>Call Us: +91 7970479666</p>
                    <br />
                    <h4>Opening Hours</h4>
                    <p>Monday - Sunday</p>
                    <p>10 AM to 06 PM</p>
                    <br />
                    <Link
                      className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor margin_top5"
                      to="/appointment"
                      onClick={() => setTab("appointment")}
                    >
                      Book Appointment
                    </Link>
                  </div>
                </aside>
              </div>
              <div className="col-lg-9 content-area">
                <div className="ttm-service-single-content-area">
                  <div className="ttm-featured-wrapper margin_bottom40">
                    <img
                      className="img-fluid"
                      src={currentSpeciality.img}
                      alt={currentSpeciality.imgAlt}
                    />
                  </div>
                  <div className="ttm-service-description">
                    <div
                      className="padding_top10"
                      dangerouslySetInnerHTML={{
                        __html: currentSpeciality.data,
                      }}
                    ></div>
                    {currentSpeciality.faqs?.length &&
                      currentSpeciality.faqs.map((item) => (
                        <Accordion
                          item={item}
                          active={active}
                          onFAQClick={onFAQClick}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Speciality;
